import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { LocalStorageService } from '../../services/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class UserGuard {

  constructor(private route: Router, private localStorageService: LocalStorageService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    let role = this.localStorageService.getRole();
    if (role !== 'Prosumer' && role !== 'Consumer' && role!=='Utility') {
      if (role === 'SuperAdmin') {
          this.route.navigateByUrl('/admin-dash/dashboard');
      } else if (role === 'ServiceProvider') {
          this.route.navigateByUrl('/provider-dash');
      } else if (role === 'IntegrationPartner') {
          this.route.navigateByUrl('/partner-dashboard');
      } else {
          this.route.navigateByUrl('/welcome');
      }
      return false
    }

    return true
  }
}
